import { RichPlacementKWordsDTO } from 'features/globalSetup/api/types/richPlacementKWordsDTO'
import { RichPlacementKWords } from 'features/globalSetup/types/richPlacementKWords'
import { WorkspaceDTO } from 'features/workspace'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { gql } from 'providers/tanstack-query/utils'

export type WorkspaceDefaults = Pick<RichPlacementKWords, 'kwordsSiteId'>

type Data = {
  workspaceRichPlacementKwordsConfiguration: Pick<RichPlacementKWordsDTO, 'kwordsSiteId'>
}

type Variables = {
  workspaceId: WorkspaceDTO['id']
}

export const useGetWorkspaceDefaults = (): undefined | WorkspaceDefaults => {
  const { workspaceId } = useWorkspaceParam()

  const { data } = useQuery<Variables, Data, WorkspaceDefaults>({
    options: {
      select: ({ workspaceRichPlacementKwordsConfiguration }: Data): WorkspaceDefaults => {
        const { kwordsSiteId } = workspaceRichPlacementKwordsConfiguration

        return { kwordsSiteId: kwordsSiteId ?? undefined }
      },
    },
    query: gql`
      query getKWordsWorkspaceDefaults($workspaceId: ID!) {
        workspaceRichPlacementKwordsConfiguration(workspaceId: $workspaceId) {
          kwordsSiteId
        }
      }
    `,
    variables: { workspaceId },
  })

  return data
}
